<div class="global-message" [ngStyle]="{ 'min-height': minHeight }">
  <app-modal-layout (closeModal)="close()" [title]="data.title">
    <div class="global-message__inner">
      <div class="message-text">
        @if (data?.text) {
          <h6>{{ data?.text }}</h6>
        }
      </div>
      @if (data?.link) {
        @if (data.link !== "closeModal") {
          <a [routerLink]="data?.link" class="_btn black medium">
            {{ data.linkText }}
          </a>
        }
        @if (data.link === "closeModal") {
          <button (click)="close()" class="_btn black medium">
            {{ data.linkText }}
          </button>
        }
      }
    </div>
  </app-modal-layout>
</div>
